import(/* webpackMode: "eager", webpackExports: ["BlocksRenderer"] */ "/Users/joseph/projects/moneyline/client/node_modules/@strapi/blocks-react-renderer/dist/BlocksRenderer.mjs");
;
import(/* webpackMode: "eager" */ "/Users/joseph/projects/moneyline/client/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/joseph/projects/moneyline/client/src/app/(public)/sportsbooks/slider.tsx");
;
import(/* webpackMode: "eager" */ "/Users/joseph/projects/moneyline/client/src/app/(public)/sportsbooks/styles.module.css");
;
import(/* webpackMode: "eager" */ "/Users/joseph/projects/moneyline/client/src/components/primitives/button.tsx");
